module.exports = __webpack_public_path__ + "static/media/blog-min.c945985b.png";